import immutable from 'object-path-immutable';
import {
  FETCH_PRODUCTS_BY_QUERY,
  FetchProductsByQueryAction,
} from '../actions/product.actionTypes';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import { LOGOUT, LogoutAction } from '../actions/auth.actionTypes';
import { CourseMindItemSearchResult } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import { FETCH_NEW_COURSES } from '../actions/course.actionTypes';
import { FetchNewCoursesAction } from '../actions/course.actionTypes';
import { PIN_MIND_ITEM, UNPIN_DOCUMENT } from '../actions/pinned.actionTypes';

import { PinMindItemAction, UnpinDocumentAction } from '../actions/pinned.actionTypes';

type ActionTypes = 
FetchProductsByQueryAction | LogoutAction | FetchNewCoursesAction | PinMindItemAction | UnpinDocumentAction;

export interface DashboardInitialStateType {
  productsBySubjectId: {
    [key: string]: {
      ids: string[];
      error?: string;
      status: AsyncActionStatus;
    };
  };
  newCourses: {
    data: CourseMindItemSearchResult[];
    status: AsyncActionStatus;
  };
}

const initialState: DashboardInitialStateType = {
  productsBySubjectId: {},
  newCourses: {
    data: [],
    status: AsyncActionStatus.INITIAL,
  },
};

const collections = (state = initialState, action: ActionTypes): DashboardInitialStateType => {
  switch (action.type) {
    case LOGOUT.SUCCESS:
      return initialState;

    case FETCH_PRODUCTS_BY_QUERY.START: {
      const { query } = action.payload;
      if (!query.subjects || query.subjects.length === 0) {
        return state;
      }

      let key: string = query.subjects.join(',');
      if (query.keyPrefix) {
        key = `${query.keyPrefix}-${key}`;
      }

      return immutable(state)
        .set(['productsBySubjectId', key, 'status'], AsyncActionStatus.LOADING)
        .set(['productsBySubjectId', key, 'ids'], [])
        .value();
    }
    case FETCH_PRODUCTS_BY_QUERY.ERROR: {
      const { query } = action.payload;
      if (!query.subjects || query.subjects.length === 0) {
        return state;
      }

      let key: string  = query.subjects.join(',');
      if (query.keyPrefix) {
        key = `${query.keyPrefix}-${key}`;
      }

      return immutable(state)
        .set(['productsBySubjectId', key, 'status'], AsyncActionStatus.ERROR)
        .value();
    }
    case FETCH_PRODUCTS_BY_QUERY.SUCCESS: {
      const { query } = action.payload;
      if (!query.subjects || query.subjects.length === 0) {
        return state;
      }
      
      let key: string  = query.subjects.join(',');
      if (query.keyPrefix) {
        key = `${query.keyPrefix}-${key}`;
      }

      return immutable(state)
        .set(['productsBySubjectId', key, 'status'], AsyncActionStatus.READY)
        .set(['productsBySubjectId', key, 'ids'], action.result.map(r => r.id))
        .value();
    }

    case FETCH_NEW_COURSES.START: {
      return immutable(state)
        .set('newCourses', {
          data: [],
          status: AsyncActionStatus.LOADING,
        })
        .value();
    }

    case FETCH_NEW_COURSES.ERROR: {
      return immutable(state)
        .set('newCourses', {
          data: [],
          status: AsyncActionStatus.ERROR,
        })
        .value();
    }
       
    case FETCH_NEW_COURSES.SUCCESS: {
      const { result } = action;

      return immutable(state)
        .set('newCourses', {
          data: result.data,
          status: AsyncActionStatus.READY,
        })
        .value();
    }

    case PIN_MIND_ITEM.SUCCESS: {
      const { id } = action.payload;

      const newCourses = state.newCourses.data.map((course) => {
        if (course.id === id) {
          return {
            ...course,
            isPinned: true,
          };
        }
        return course;
      });

      return immutable(state)
        .set('newCourses', {
          data: newCourses,
          status: AsyncActionStatus.READY,
        })
        .value();
    }

    case UNPIN_DOCUMENT.SUCCESS: {
      const { id } = action.payload;

      const newCourses = state.newCourses.data.map((course) => {
        if (course.id === id) {
          return {
            ...course,
            isPinned: false,
          };
        }
        return course;
      });

      return immutable(state)
        .set('newCourses', {
          data: newCourses,
          status: AsyncActionStatus.READY,
        })
        .value();
    }
  }

  return state;
};

export default collections;
